import { BarSeries } from '../types/chart';
import { ChartRef } from '../types/refs';
import { BarSeriesOptions } from '../types/series-options';

export function barSeries<TRow extends object>(
  ref: ChartRef<TRow>,
  options: BarSeriesOptions<TRow>,
): BarSeries<TRow> {
  const series: BarSeries<TRow> = { ...options, type: 'bar' };
  ref.createSeries(series);
  return series;
}
